import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./rootSaga";

// Import reducers
import authReducer from "./slices/authSlice";
import configReducer from "./slices/configSlice";
import contentReducer from "./slices/contentSlice";
import deviceReducer from "./slices/deviceSlice";
import doctorsReducer from "./slices/doctorsSlice";
import goalsReducer from "./slices/goalsSlice";
import insightsReducer from "./slices/insightsSlice";
import labTestReducer from "./slices/labTestSlice";
import locationReducer from "./slices/locationSlice";
import medicationReducer from "./slices/medicationSlice";
import offersReducer from "./slices/offersSlice";
import onboardingReducer from "./slices/onboardingSlice";
import patientReducer from "./slices/patientSlice";
import programReducer from "./slices/programSlice";
import razorPayReducer from "./slices/razorPaySlice";
import recordsReducer from "./slices/recordsSlice";
import reminderReducer from "./slices/reminder";
import appointmentReducer from "./slices/appointmentsSlice";
import orderHistoryReducer from "./slices/orderHistorySlice";
import journeyReducer from "./slices/journeySlice";
import symptomsReducer from "./slices/symptomsSlice";
import walletReducer from "./slices/walletSlice";
import cgmReducer from "./slices/cgmSlice";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    auth: authReducer,
    config: configReducer,
    content: contentReducer,
    device: deviceReducer,
    doctors: doctorsReducer,
    goals: goalsReducer,
    insights: insightsReducer,
    labTest: labTestReducer,
    location: locationReducer,
    medication: medicationReducer,
    offers: offersReducer,
    onboarding: onboardingReducer,
    patient: patientReducer,
    program: programReducer,
    razorPay: razorPayReducer,
    records: recordsReducer,
    reminder: reminderReducer,
    appointments: appointmentReducer,
    orderHistory: orderHistoryReducer,
    journey: journeyReducer,
    symptoms: symptomsReducer,
    wallet: walletReducer,
    cgm: cgmReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: {
        // Ignore non-serializable values in these paths
        ignoredActionPaths: [
          "payload.resolve",
          "payload.reject",
          "payload.payload.resolve",
          "payload.payload.reject",
          "payload.payload",
        ],
      },
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
